import styled from 'styled-components';
import { pxToRem } from '@vfit/shared/themes';

export const Ul = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${pxToRem(12)};
  margin: 0;
  padding: ${pxToRem(4, 0)};
`;

